import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkOrderComponent } from './bulk-order.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { ShareModuleModule } from 'src/@order/directive/share-module.module';
import { CommonComponentsModule } from 'src/@order/components/common-components.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DialogModule } from "src/@order/dialogs/dialog.module";

@NgModule({
  declarations: [BulkOrderComponent],
  imports: [
    CommonModule,
    ShareModuleModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    FormsModule,
    MatDatepickerModule,
    RouterModule,
    CommonComponentsModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    MatDialogModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatIconModule,
    NgxMatNativeDateModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatDividerModule,
    MatSidenavModule,
    DialogModule
],
})
export class BulkOrderModule {}
